export const PermPlacementDetailsGetters = {
  CurrentPermPlacement: 'PermPlacementDetailsGetters.CurrentPermPlacement',
  SelectedRecordHistory: 'PermPlacementDetailsGetters.SelectedRecordHistory',
  CurrentPermPlacementHistories: 'PermPlacementDetailsGetters.CurrentPermPlacementHistories',
  CurrentPermPlacementAttachments: 'PermPlacementDetailsGetters.CurrentPermPlacementAttachments',
  GetPermPlacementDetailsValidationErrors:
    'PermPlacementDetailsGetters.GetPermPlacementDetailsValidationErrors'
};

export const PermPlacementDetailsActions = {
  RetrievePermPlacement: 'PermPlacementDetailsActions.RetrievePermPlacement',
  RetrievePermPlacementAttachments: 'PermPlacementDetailsActions.RetrievePermPlacementAttachments',
  RetrievePermPlacementHistories: 'PermPlacementDetailsActions.RetrievePermPlacementHistories',
  DoPermPlacementAction: 'PermPlacementDetailsActions.DoPermPlacementAction',
  ResetPermPlacementState: 'PermPlacementDetailsActions.ResetPermPlacementState',
  UpdatePermPlacementValidationErrors:
    'PermPlacementDetailsActions.UpdatePermPlacementValidationErrors'
};

export const PermPlacementDetailsMutations = {
  RetrievePermPlacementSuccess: 'PermPlacementDetailsMutations.RetrievePermPlacementSuccess',
  RetrievePermPlacementHistoriesSuccess:
    'PermPlacementDetailsMutations.RetrievePermPlacementHistoriesSuccess',
  RetrievePermPlacementAttachmentsSuccess:
    'PermPlacementDetailsMutations.RetrievePermPlacementAttachmentsSuccess',
  SetLoading: 'PermPlacementDetailsMutations.SetLoading',
  ResetPermPlacementState: 'PermPlacementDetailsMutations.ResetPermPlacementState',
  SetPermPlacementValidationErrors: 'PermPlacementDetailsMutations.SetPermPlacementValidationErrors'
};
